export function limiter<T>(demo: boolean, limit: number): (items: T[]) => T[] {
  return demo ? (items) => items.slice(0, limit) : (items) => items;
}
